<template>
  <svg
      xmlns:dc="http://purl.org/dc/elements/1.1/"
      xmlns:cc="http://creativecommons.org/ns#"
      xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
      xmlns:svg="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      width="27.181641"
      height="19.589844"
      viewBox="0 0 27.181641 19.589844"
      version="1.1"
      style="fill:none"
  >
    <g
        id="g4591"
        transform="translate(4.7352733,-11.773287)">
      <path
          d="m 22.207071,20.924306 -4.240802,-4.240802 c -0.323855,-0.323855 -0.85437,-0.318296 -1.185118,0.01245 -0.330714,0.330714 -0.336279,0.861235 -0.01242,1.18509 l 3.654536,3.65454 -3.732307,3.732307 c -0.330721,0.330721 -0.33635,0.861164 -0.0125,1.185019 0.323855,0.323855 0.854369,0.318297 1.18509,-0.01242 l 4.331069,-4.331064 c 0.330749,-0.330748 0.336307,-0.861263 0.01245,-1.185118 z"
          id="path864"
          class="icon-fill" />
      <path
          d="m 20.423267,21.535586 c 0.0049,-0.462968 -0.366046,-0.833916 -0.829012,-0.829012 L 2.6873007,20.884526 c -0.462758,0.0046 -0.8419802,0.38386 -0.8466177,0.846618 -0.0026,0.231288 0.08899,0.439857 0.2390861,0.589954 0.1498785,0.149879 0.3584537,0.241499 0.5899536,0.239088 L 19.576617,22.382234 c 0.462745,-0.0047 0.841963,-0.383899 0.84665,-0.846648 z"
          id="path866"
          class="icon-fill" />
    </g>
    <path
        class="icon-fill"
        d="M 0.83007812,0 C 0.37207413,1e-7 0,0.3799563 0,0.8476563 V 18.742188 c 0,0.46775 0.37207412,0.847656 0.83007812,0.847656 H 10.861328 18.351562 c 0.458201,0 0.830079,-0.379856 0.830079,-0.847656 v -4.246094 c 0,-0.4677 -0.372179,-0.845703 -0.830079,-0.845703 -0.457999,0 -0.828124,0.378003 -0.828124,0.845703 v 3.400391 H 10.861328 1.6582031 V 1.6933594 h 9.2031249 6.66211 V 5.09375 c 0,0.4677002 0.370125,0.8457032 0.828124,0.8457032 0.4579,0 0.830079,-0.378003 0.830079,-0.8457032 V 0.8476563 C 19.181641,0.3798563 18.809763,0 18.351562,0 h -7.490234 z"
        id="path868"
    />

  </svg>


</template>

<script>
export default {
  name: 'logout'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}

</style>